import { __extends } from "tslib";
import { AVMStage, AVMEvent, AVMVERSION } from "@awayfl/swf-loader";
import { AVMDebug } from "./AVMDebugInterface";
import { AVM1Handler } from '@awayfl/avm1';
import { AVM2Handler, extClasses } from '@awayfl/avm2';
import { PlayerGlobal } from "@awayfl/playerglobal";
var AVMPlayer = /** @class */ (function (_super) {
    __extends(AVMPlayer, _super);
    function AVMPlayer(gameConfig) {
        var _this = _super.call(this, gameConfig) || this;
        if (gameConfig.externalLib) {
            extClasses.lib = gameConfig.externalLib;
        }
        _this.registerAVMStageHandler(new AVM1Handler());
        _this.registerAVMStageHandler(new AVM2Handler(new PlayerGlobal()));
        _this.addEventListener(AVMEvent.AVM_COMPLETE, function (event) { return _this.onAVMAvailable(event); });
        // export player api
        //if(!release) {
        _this._debug = new AVMDebug(_this);
        return _this;
        //}
    }
    AVMPlayer.prototype.onAVMAvailable = function (event) {
        if (this._debug) {
            this._debug.onAvmInit(event.avmVersion === AVMVERSION.AVM1 ? 1 : 2);
        }
    };
    return AVMPlayer;
}(AVMStage));
export { AVMPlayer };
